module.exports = __webpack_public_path__ + "static/favicon-4028b495d6029cb4196fb879d4a79460.png";